import React from 'react';
import {
  TextField,
  ReferenceField,
  TextInput,
  SelectInput,
  DateInput,
  ReferenceInput, FunctionField
} from 'react-admin';

import ListFilter from '../../components/poc/ListWithLayout/components/ListFilter';
import ListWithLayout from '../../components/poc/ListWithLayout';
import Actions from '../../components/poc/Grid/Row/Actions';

import {deletePermission, editPermission} from './permissions';

import session from '../../app/session';
import config from "../../app/etc/config";
import {formatClientName} from "../../components/poc/Grid/Fields";

const TableFilter = (props) => (
  <ListFilter {...props}>
    <TextInput source="id:in" label="ID"/>
    <TextInput source="name"/>

    {session.hasAdminPermission() &&
      <ReferenceInput label="Client" reference="client" source="client_id" perPage={config.pagination.associated} sort={{field: 'name', order: 'ASC'}}>
        <SelectInput optionText={formatClientName}/>
      </ReferenceInput>
    }

    <DateInput source="created_at"/>
    <DateInput source="updated_at"/>
  </ListFilter>
);

export const TableGrid = (props) => {
  return (
    <ListWithLayout
      {...props}
      filters={<TableFilter/>}
      resource="table"
      perPage={config.pagination.grid}
      sort={{field: 'created_at', order: 'DESC'}}
      createButton={true}
    >
      <TextField source="id"/>
      <TextField source="name"/>

      {session.hasAdminPermission() &&
        <ReferenceField label="Client" reference="client" source="client_id" sortable={false}>
          <FunctionField render={formatClientName}/>
        </ReferenceField>
      }

      <TextField source="rows_number"/>
      <TextField source="cols_number"/>

      <Actions edit={editPermission} delete={deletePermission}/>
    </ListWithLayout>
  )
};
